import { EmtDrawerLink, EmtIcon, EmtTypography } from 'emt-components-v2'
import NextMuiLink from '@/components/NextMuiLink'
import { useUIStore } from '@/store/ui/uiStore'

type Props = {
  href: string
  title: string
  icon?: React.ReactNode
  iconClassName?: string
}

const DrawerNextLink: React.FC<Props> = ({ href, title, icon, iconClassName }) => {
  const { closeDrawer } = useUIStore()

  if (!href.length || href === '#') {
    return null
  }

  return (
    <NextMuiLink href={href} sx={{ textDecoration: 'none' }} onClick={closeDrawer}>
      <EmtDrawerLink>
        <>
          {icon || <EmtIcon className={iconClassName} color="primary" />}
          <EmtTypography variant="body1" color="black">
            {title}
          </EmtTypography>
        </>
      </EmtDrawerLink>
    </NextMuiLink>
  )
}

export default DrawerNextLink
